import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./MethodBanner.module.css";

export function MethodBanner() {
  const { brand, testimonials } = useMaestriaContent();

  return (
    <section className={`maestria-section ${styles.section}`} aria-labelledby="method-banner-title">
      <div className={`${styles.inner}`}>
        <h2 id="method-banner-title" className={styles.title}>
          <span>
            {testimonials.title.replace(testimonials.titleBold, "")}
            <strong>{testimonials.titleBold}</strong>
          </span>
          <img
            className={styles.logo}
            src={brand.wordmarkGold}
            alt={brand.name}
            width={148}
            height={33}
          />
        </h2>
      </div>
    </section>
  );
}
